export default {"src":"https://assets.madeeasy.in/non-prod/_next/static/media/handouts.f816dcc5.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};